<!--https://github.com/vuetifyjs/vuetify/issues/238 -->
<template>
  <div>
    <label class="cmr-label-text">Select File</label>
    <v-text-field
      :error-messages="errorMessage"
      :rules="rules"
      dense
      outlined
      :prepend-inner-icon="icon"
      v-model="filename"
      @click.native="onFocus"
      ref="fileTextField"
    ></v-text-field>
    <input
      type="file"
      :accept="accept"
      :multiple="multiple"
      :ref="inputRef"
      @change="onFileChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      default: "*",
    },
    label: String,
    multiple: {
      type: Boolean,
      default: false,
    },
    icon: String,
    errorMessage: String,
    rules: Array,
    inputRef: {
      type: String,
      default: "fileInput",
    },
  },
  data() {
    return {
      filename: "",
    };
  },
  methods: {
    getFormData: function (files) {
      const data = new FormData();
      [...files].forEach((file) => {
        data.append("data", file, file.name);
      });
      return data;
    },
    onFocus: function () {
      this.$refs[this.inputRef].click();
    },
    onFileChange: function ($event) {
      const files = $event.target.files || $event.dataTransfer.files;
      const form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.filename = [...files].map((file) => file.name).join(", ");
        } else {
          this.filename = null;
        }
      } else {
        this.filename = $event.target.value.split("\\").pop();
      }

      if (this.multiple) {
        this.handleFiles(files);
      } else {
        this.handleFile(files);
      }
    },
    handleFile: function (files) {
      const file = files[0];
      let reader = new FileReader();
      let self = this;
      reader.readAsDataURL(file);

      reader.onload = function (e) {
        const encodingPrefix = "base64,";
        let base64File = e.target.result;

        //Strip type and encoding headers
        let startIndex =
          base64File.indexOf(encodingPrefix) + encodingPrefix.length;
        base64File = base64File.substring(startIndex);
        base64File = base64File.replace(/\+/g, "%2B");

        let fileObject = {
          name: file.name,
          type: file.type,
          size: file.size,
          data: base64File,
        };
        console.log(fileObject);
        self.$emit("fileInput", fileObject);
      };
    },
    handleFiles: async function (files) {
      let fileArray = [];
      for (let i = 0; i < files.length; i++) {
        try {
          const file = files[i];
          let fileObject = await this.readFileAsync(file);
          fileArray.push(fileObject);
        } catch (err) {
          console.log(err);
        }
      }
      this.$emit("fileInput", fileArray);
    },
    readFileAsync: function (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function (e) {
          const encodingPrefix = "base64,";

          let base64File = e.target.result;

          //Strip type and encoding headers
          let startIndex =
            base64File.indexOf(encodingPrefix) + encodingPrefix.length;
          base64File = base64File.substring(startIndex);
          base64File = base64File.replace(/\+/g, "%2B");
          resolve({
            name: file.name,
            type: file.type,
            size: file.size,
            data: base64File,
          });
        };

        reader.onerror = reject;
      });
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  position: absolute;
  left: -99999px;
}
</style>